export default __webpack_public_path__ + "static/media/operaciones.e6c12f69.png";